import React from 'react';
import { Check } from 'lucide-react';

const WhatsIncluded = () => {
  const included = [
    'Stakeholder discovery sessions',
    'Custom training paths built by Traain + your team',
    'Custom role play library + scoring models',
    'Recruiting workflow setup + calibration',
    'Content import + modernization',
    'Admin training + manager coaching',
    'Launch support for first live cycles',
    '30-day optimization review',
    'Ongoing success check-ins',
    'Dedicated success manager',
    'Integration assistance (ATS/LMS/CRM)',
    'Performance analytics setup'
  ];

  return (
    <section id="whats-included" className="py-20 px-6 bg-gray-950">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            What's Included
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Everything you need to launch successfully and achieve measurable results.
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-10 border border-gray-800 shadow-[0_0_50px_rgba(59,130,246,0.1)]">
          <div className="grid md:grid-cols-2 gap-6">
            {included.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-6 h-6 bg-blue-900/50 border border-blue-700 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-4 h-4 text-blue-400" />
                </div>
                <span className="text-gray-200 text-lg">{item}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-gray-700">
            <p className="text-sm text-gray-400 text-center">
              <span className="font-semibold text-blue-400">Enterprise rollouts</span> include dedicated CSM + SLA options
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;